import {Component, Host, h, Prop, EventEmitter, Event, Watch, Fragment, forceUpdate} from '@stencil/core';
import {Logger} from "../../utils/logger";
import {IRequestField} from "../../interfaces/configuration";

@Component({
  tag: 'securecall-request-radio',
  styleUrl: 'securecall-request-radio.css',
  shadow: true,
})
export class SecurecallRequestRadio {
  @Prop() fieldName: string;
  @Prop({ mutable: true }) config: IRequestField;

  @Event() requestRadioChangeEvent: EventEmitter<{ field: string, value: string }>
  @Event() isValidEvent: EventEmitter<{ field: string, valid: boolean, value: string }>;

  private readonly log = Logger('SecurecallRequestRadio')

  public get value(): string {
    return this.config.value;
  }
  public set value(value: string) {
    this.config.value = value;
    this.handleLocalStorageChange();
  }

  @Watch('config')
  handleConfigChange(newConfig: any, oldConfig: any) {
    this.log.debug(this.fieldName + ": handleConfigChange: config", newConfig, oldConfig);
    if(oldConfig.value !== newConfig.value) {
      this.value = newConfig.value;
    } else if(oldConfig.valid !== newConfig.valid) {
      this.validateChange(this.value);
    }
  }

  componentWillLoad() {
    // Trigger the first time we are loaded so the other fields can be hidden/revealed
    this.requestRadioChangeEvent.emit({field: this.fieldName, value: this.value});
    this.validateChange(this.value);
  }

  private handleLocalStorageChange() {
    this.log.debug("handleChangeFromLocalStorage: string change:", this.value);
    this.requestRadioChangeEvent.emit({field: this.fieldName, value: this.value});
    this.validateChange(this.value);
    forceUpdate(this);
  }

  handleChange(ev) {
    this.log.debug("handleChange: string change:", ev.target.value)
    this.requestRadioChangeEvent.emit({field: this.fieldName, value: ev.target.value});
    this.validateChange(ev.target.value);
  }

  validateChange(input: string) {
    let isValid = false;
    if(this.config.possibleValues?.[input] !== undefined)
      isValid = true;
    this.isValidEvent.emit({ field: this.fieldName, valid: isValid, value: input });
  }

  render() {
    return (
      <Host>
        <div class="field-container">
          <label class="custom-label" htmlFor={this.fieldName}>
            {this.config.label}:
          </label>
          <div class="radio-group">
            {Object.entries(this.config.possibleValues || {}).map(([val, label], _index) => (
              <Fragment>
                <input
                  class="radio-input"
                  type="radio"
                  name={this.fieldName}
                  id={this.fieldName + "-" + val}
                  value={val}
                  checked={val === this.config.value}
                  onChange={(ev) => this.handleChange(ev)}
                  disabled={this.config.readOnly}
                />
                <label class="radio-label" htmlFor={this.fieldName + "-" + val}>
                  {label}
                </label>
              </Fragment>
            ))}
          </div>
        </div>
      </Host>
    );
  }
}
